import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import _uniqueId from "lodash/uniqueId";

import { AppContext } from "../../context/AppContext";
import { ProgressBar, Layout, Tooltip } from "../../components";
import { Button, Headline, TextInput, Select, Checkbox } from "../../elements";

import { BUILDING_PAGE, DIMENSIONS_PAGE, OVERVIEW } from "../../navigation/routes";
import { ADD_ELEVATOR, REMOVE_ELEVATOR, SET_MODE, UPDATE_ELEVATOR_DATA } from "../../context/ActionTypes";
import { installation_types } from "../../data/options.json";
import styles from "./ElevatorPage.module.scss";

const ElevatorPage = (props) => {
  const { state, dispatch } = React.useContext(AppContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({ criteriaMode: "all", mode: "onSubmit" });
  const navigate = useNavigate();
  const { id } = useParams();
  const elevatorData = state.configuration.elevators ? state.configuration.elevators[state.elevatorIndex] : null;

  const onSubmit = (data) => {
    if (state.mode === "new") {
      dispatch({ type: ADD_ELEVATOR, payload: { ...data } });
    } else {
      dispatch({ type: UPDATE_ELEVATOR_DATA, payload: { ...data } });
    }

    navigate(`${DIMENSIONS_PAGE}/${id ? id : ""}`);
  };

  const handleBack = () => {
    if (id) {
      if (state.configuration.elevators[id] && state.mode === "new") {
        dispatch({ type: REMOVE_ELEVATOR, payload: id });
      }
      navigate(OVERVIEW);
    } else {
      navigate(BUILDING_PAGE);
    }

    dispatch({ type: SET_MODE, payload: "completed" });
  };

  return (
    <Layout>
      <ProgressBar />
      <Headline variant="h2">Informationen zum Aufzug</Headline>

      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          type="text"
          label="Name des Aufzugs"
          errors={errors}
          tooltip="Equipmentnr. oder kurze Beschreibung zum Aufzug z.B. Standort im Gebäude"
          defaultValue={elevatorData ? elevatorData.display_name : ""}
          {...register("display_name", { required: true })}
        />

        <TextInput
          type="number"
          min="0"
          label="Anzahl Stockwerke"
          errors={errors}
          defaultValue={elevatorData ? elevatorData.floors : ""}
          {...register("floors", { required: true, min: { value: 0 } })}
        />

        <Controller
          control={control}
          name="installation_location"
          rules={{ required: true }}
          defaultValue={elevatorData ? elevatorData.installation_location : "inside"}
          render={({ field }) => (
            <Select
              inputRef={field.ref}
              label="Ort der Installation"
              options={installation_types}
              name={field.name}
              disabled
              value={field.value ? installation_types.find((opt) => opt.value === field.value).label : null}
              onChange={(val) => field.onChange(val)}
              errors={errors}
            />
          )}
        />

        <div className={styles.inputWithTooltip}>
          <Checkbox
            id={_uniqueId("checkbox_")}
            label="Glas-/Spiegelverkleidung im Interieur?"
            errors={errors}
            {...register("glass_interieur")}
            defaultChecked={elevatorData ? elevatorData.glass_interieur : ""}
          />
          <Tooltip content="Kabineninnenverkleidung vollflächig aus Glas-/Spiegelelementen" />
        </div>

        <div className={styles.inputWithTooltip}>
          <Checkbox
            id={_uniqueId("checkbox_")}
            label="Durchlader"
            errors={errors}
            {...register("throughloader")}
            defaultChecked={elevatorData ? elevatorData.throughloader : ""}
          />
          <Tooltip content="Kabine mit zwei gegenüberliegenden Zugängen" />
        </div>

        <div className={styles.inputWithTooltip}>
          <Checkbox
            id={_uniqueId("checkbox_")}
            label="Glaskabine"
            errors={errors}
            {...register("glass_cabin")}
            defaultChecked={elevatorData ? elevatorData.glass_cabin : ""}
          />
          <Tooltip content="Vollverglasung der Kabine" />
        </div>

        <div className={styles.footer}>
          <Button type="button" title={id ? "Abbrechen" : "Zurück"} variant="outline" onClick={() => handleBack()} />
          <Button type="submit" title="Weiter" />
        </div>
      </form>
    </Layout>
  );
};

export default ElevatorPage;
